var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 13.125C2.07147 13.125 1.96019 13.0789 1.87814 12.9969C1.79609 12.9148 1.75 12.8035 1.75 12.6875V1.86293C1.75003 1.7483 1.78009 1.63568 1.83718 1.53628C1.89427 1.43687 1.9764 1.35416 2.07539 1.29637C2.40625 1.10414 3.07289 0.875 4.375 0.875C5.39246 0.875 6.53051 1.27723 7.53457 1.63188C8.34312 1.91762 9.10684 2.1875 9.625 2.1875C10.292 2.18545 10.952 2.05067 11.5664 1.79102C11.6412 1.75943 11.7227 1.74685 11.8036 1.7544C11.8844 1.76195 11.9622 1.78939 12.0298 1.83428C12.0975 1.87917 12.153 1.9401 12.1915 2.01166C12.2299 2.08321 12.25 2.16316 12.25 2.24437V8.2425C12.2499 8.34881 12.2188 8.45279 12.1605 8.54171C12.1022 8.63063 12.0193 8.70064 11.9219 8.74316C11.6837 8.84734 10.8142 9.1875 9.625 9.1875C8.96492 9.1875 8.13805 8.99227 7.26277 8.78527C6.27894 8.55285 5.26176 8.3125 4.375 8.3125C3.36684 8.3125 2.85086 8.46508 2.625 8.5616V12.6875C2.625 12.8035 2.57891 12.9148 2.49686 12.9969C2.41481 13.0789 2.30353 13.125 2.1875 13.125Z",
    fill: "#AA8768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndPoint);
export default __webpack_public_path__ + "static/media/EndPoint.ed28dc06d9a32ae3a590f5c76c15b073.svg";
export { ForwardRef as ReactComponent };